module.exports = __webpack_public_path__ + "static/media/gold-star-bigeyes.541dc5be.png";